export default __webpack_public_path__ + "static/media/InbellezzaIcon.e575b268.svg";